import { memo, useCallback } from "react";

// UI
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { DatePicker } from "ui/components/DatePicker";

import { getStatusField } from "../fields";
import { VehicleStatusFieldsProps } from "../types";

/**
 * U dolasku. Odgovara `VehicleStatusArrivalDetail` na backendu — dobavljač je neobavezan,
 * obavezan je očekivani datum dolaska iz baznog zapisa.
 */
const VehicleStatusArrivalFields: React.FC<VehicleStatusFieldsProps> = (props) => {
  const { status, values, errors, onChange } = props;

  const validFromField = getStatusField(status, "validFrom");
  const contactField = getStatusField(status, "contact");

  const handleDateChange = useCallback(
    (name: string, value: Date | null) => {
      onChange({ [name]: value });
    },
    [onChange]
  );

  const handleContactChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onChange({ contactId: item.value || null });
    },
    [onChange]
  );

  // Isti raspored kao ostali statusi: dva stupca, polje uz polje.
  return (
    <div className="grid grid-cols-2 gap-3">
      {validFromField && (
        <div>
          <DatePicker
            name="validFrom"
            label={validFromField.label}
            placeholder={validFromField.label}
            value={values.validFrom}
            onChange={handleDateChange}
            error={errors.validFrom}
            required={validFromField.required}
            width="full"
          />
        </div>
      )}

      {contactField && (
        <div>
          <ContactDropdown
            name="contactId"
            label={contactField.label}
            placeholder={`Odaberite: ${contactField.label.toLowerCase()}`}
            value={values.contactId}
            onChange={handleContactChange}
            contactGroupIds={contactField.contactGroupIds}
            error={errors.contactId}
            required={contactField.required}
            width="full"
          />
        </div>
      )}
    </div>
  );
};

export default memo(VehicleStatusArrivalFields);
